<template>
    <div v-if="local_alerte_sms.propose">
        <div class="spo-card rounded bordered p-1 my-2">
            <div class="text-h6">Alerte de suivi par SMS</div>
            <div>
                <v-checkbox color="primary-dark" hide-details @change="onChange"
                    :label="'Souscrire au suivi SMS pour ' + local_alerte_sms.prix + '€'"
                    v-model="local_alerte_sms.selected">
                </v-checkbox>
                <div class="text-body mt-2">
                    Tenez informés jusqu'à 3 de vos accompagnants. Du départ à l'arrivée, ils seront informés par SMS
                    (numéros français uniquement) de vos passages intermédiaires et vos estimations aux points suivants
                    jusqu'au classement d'arrivée. En cas d'abandon, on les prévient aussi. Vous pourrez
                    renseigner/modifier
                    les numéros de téléphone de vos accompagnants dans votre fiche coureur jusqu'au jour de la course.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["alerte_sms", "commande_inscription"],
    data() {
        return {
            local_alerte_sms: {}
        };
    },
    mounted() {
        this.local_alerte_sms = this.alerte_sms;
    },
    methods: {
        onChange() {
            // Synchroniser la prop avec le modèle local
            Object.assign(this.alerte_sms, { selected: this.local_alerte_sms.selected });
            this.$emit("updateAlerteSMS");
        }
    }
};
</script>

<style lang="scss" scoped></style>
